import React from 'react';
import styles from '../../styles/bio/bio_option.scss';
import {OptionActiveIcon} from "../svg/OptionActiveIcon";
import {OptionInactiveIcon} from "../svg/OptionInactiveIcon";


export const BioOption = props => {
    return (
        <div className={styles.optionContainer} onClick={props.onClick}>
            {props.active ? <OptionActiveIcon className={styles.optionStatusIcon}/> : <OptionInactiveIcon className={styles.optionStatusIcon}/>}
            <div className={styles.optionText}>{props.text}</div>
            ({<props.IconComp className={styles.optionIcon}/>})
        </div>
    )
};
